import React from "react";
import { FormProvider } from "react-hook-form";
import { makeStyles } from "@material-ui/styles";

const useStyles = makeStyles((theme) => ({
  root: {
    borderRadius: theme.shape.borderRadius,
    position: "relative",
    [theme.breakpoints.up("md")]: {
      borderRadius: theme.shape.borderRadiusAlt,
      marginBottom: theme.spacing(1),
    },
  },
}));

const Form = ({ children, form, onSubmit, ...props }) => {
  const classes = useStyles();

  return (
    <FormProvider {...form}>
      <form
        {...props}
        className={classes.root}
        onSubmit={form.handleSubmit(onSubmit)}
      >
        {children}
      </form>
    </FormProvider>
  );
};

export default Form;
